import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../../core/auth/auth.service';
import { UserService } from '../../../../core/user.service';
import * as Chart from "chart.js";

@Component({
  selector: 'app-cqmns-project-cards',
  templateUrl: './cqmns-project-cards.component.html',
  styleUrls: ['./cqmns-project-cards.component.css']
})
export class CqmnsProjectCardsComponent implements OnInit {
  accuracy: any;
  accurate: any;
  scanned = 0;
  classified = 0;
  issues: any;
  scannedOn = '';
  classifiedOn = '';
  approvedOn = '';
  approved = 0;
  pending = 0;
  autoClassified = 0;
  projectID: any;
  source: any;
  source1: any;
  source2: any;
  source3: any;
  source4: any;
  source5: any;
  hostUrl;
  assigned = 0;
  countBySource: Object;
  issuesSource: Object;
  classifications = [];
  noOfClassifications = [];
    userId: any;

  constructor(private http: HttpClient, private authService: AuthService, private route: ActivatedRoute, private userService: UserService) {
      this.accuracy = 0.0;
      this.accurate = 0.0;
  }

  ngOnInit() {
    this.authService.user() .subscribe(
        data => {});
      this.hostUrl=this.userService.getUrl();
     // this.projectID = this.route.snapshot.params['projectId'];
     this.userId = localStorage.getItem("userid");

      this.projectID = localStorage.getItem("projectId");


      /* To get the number of all the issues of the project */
      // this.http.get(encodeURI(this.hostUrl+'/api/issue/' + this.projectID)).subscribe(data => {
      //     this.issues = data;
      //     this.scanned += this.issues.length;
      //     this.scannedOn = this.issues[this.issues.length - 1].ScannedOn;
      //     console.log(this.scannedOn)
      // });
      this.http.get(encodeURI(this.hostUrl+'/configure/projectSourceId/' + this.projectID))
      .subscribe(data => {
          var data1 = data;
          if(data1['length']==1){
          this.source =  data1[0].source;
          // this.source1 = data1[1].source;
          // this.source2 = data1[2].source;
          // this.source3 = data1[3].source;
          // this.source4 = data1[4].source;
          // this.source5 = data1[5].source;
          }
          if(data1['length']==2){
              this.source = data1[0].source+","+ data1[1].source;
              // this.source1 =;
              // this.source2 = data1[2].source;
              // this.source3 = data1[3].source;
              // this.source4 = data1[4].source;
              // this.source5 = data1[5].source;

              }
              if(data1['length']==3){
                  this.source = data1[0].source+", "+data1[1].source+", " +data1[2].source;
                  // this.source1 = data1[1].source+", ";
                  // this.source2 = data1[2].source;
                  // this.source3 = data1[3].source;
                  // this.source4 = data1[4].source;
                  // this.source5 = data1[5].source;
                  }
                  if(data1['length']==4){
                      this.source = data1[0].source+", "+data1[1].source+", "+ data1[2].source+", "+data1[3].source;
                      // this.source1 = data1[1].source+", ";
                      // this.source2 = data1[2].source+", ";
                      // this.source3 = data1[3].source;
                      // this.source4 = data1[4].source;
                      // this.source5 = data1[5].source;
                      }
                      if(data1['length']==4){
                          this.source = data1[0].source+", "+data1[1].source+","
                          +data1[2].source+","+data1[3].source+","+data1[4].source;
                          // this.source1 = data1[1].source+",";
                          // this.source2 = data1[2].source+",";
                          // this.source3 = data1[3].source+",";
                          // this.source4 = data1[4].source;
                          // this.source5 = data1[5].source;
                          }
                          if(data1['length']==5){
                              this.source = data1[0].source+", "+data1[1].source+","
                              +data1[2].source+","+data1[3].source+","+data1[4].source+","+data1[5].source;
                              // this.source1 = data1[1].source+", ";
                              // this.source2 = data1[2].source+", ";
                              // this.source3 = data1[3].source+", ";
                              // this.source4 = data1[4].source+", ";
                              // this.source5 = data1[5].source;
                              }
      });
      this.getCorrectClassified();
      this.getApproved();
      this.getClassified();
      this.getScanned();
      this.getPending();
      this.getAccuracy();


  }
getScanned(){
    this.http.get(encodeURI(this.hostUrl+'/api/issue/byScanned/' + this.projectID)).subscribe(data => {
        this.issues = data;
        this.scanned += this.issues.length;
        if(this.issues.length){
            this.scannedOn = this.issues[this.issues.length - 1].SCANNEDON;
        }
    });
}
getClassified(){
/* To get the number of all the classified issues in the project */
this.http.get(encodeURI(this.hostUrl+'/api/issue/byclassstatus/' + this.projectID + '/1')).subscribe(data => {
    this.issues = data;

    this.classified += this.issues.length;
    if(this.issues.length){
    this.classifiedOn = this.issues[this.issues.length - 1].CLASSIFIEDON;
    console.log(this.classifiedOn)
    }

});
}
getApproved(){
  /* To get all the issues verified */
  this.http.get(encodeURI(this.hostUrl+'/api/issue/bystatus/' + this.projectID + '/1/1')).subscribe(data => {
    this.issues = data;
    if(this.issues.length){
    this.approved += this.issues.length;
    this.approvedOn = this.issues[this.issues.length - 1].ApprovedOn;
    }
});

}
getPending(){
      /* To get all the unverified issues */
      this.http.get(encodeURI(this.hostUrl+'/api/issue/bystatus/' + this.projectID + '/1/0')).subscribe(data => {
        this.issues = data;
        this.pending += this.issues.length;
    });
}
getCorrectClassified(){
    /* To get the number of correctly classified issues*/
    this.http.get(encodeURI(this.hostUrl+'/api/issue/byclassType/' + this.projectID + '/0')).subscribe(data => {
        this.issues = data;
        this.autoClassified += this.issues.length;
        
    });
}
getAccuracy(){
    setTimeout(() => {if (this.approved !== 0) {
        this.accuracy = parseFloat(String((this.autoClassified / this.approved) * 100)).toFixed(0);
    }}
    , 1500 );
    console.log(this.autoClassified,this.approved,this.accuracy)

    setTimeout(() => {if (this.classified !== 0) {
        this.accurate = parseFloat(String((this.classified *  100) / this.scanned)).toFixed(0);
    }}
    , 1500 );
}
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-defect/cqmns-project-cards/cqmns-project-cards.component.ts